import { Navigate, Outlet } from "react-router-dom";
import Header from "./Header";
import { Suspense, useContext } from "react";
import { ConfigContext } from "../Context/ConfigContext";
import { jwtDecode } from "jwt-decode";

const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    if (!exp) return true;
    const currentTime = Date.now() / 1000;
    return exp < currentTime;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return true;
  }
};
const ProtectedRoutes = ({ children }) => {
  const { token } = useContext(ConfigContext);

  if (!token || isTokenExpired(token)) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default function AppLayout() {
  return (
    <ProtectedRoutes>
      <Header />
      <Suspense fallback={<div>Loading...</div>}>
        <Outlet />
      </Suspense>
    </ProtectedRoutes>
  );
}
